export const getTimeSeriesResources = (timeSeriesResources)=>timeSeriesResources.filter((tsr)=>(!tsr.parents || tsr.parents.length === 0) && tsr.resourceType !== 'Nutrition');
